import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCrmCallsSlice = (set, get) => ({
    crmCalls: {
        loading: false,
        data: []
    },
    getCrmCalls: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCalls: { ...state.crmCalls, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-histories/${insuranceRequestId}/calls`,
                headers: { token }
            });
            set(state => ({ crmCalls: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCalls: { loading: false, data: [] } }));
        }
    }
});
